import React, { Suspense } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export default function CameraModelSettings() {
  const { control } = useFormContext();

  const loadModule = (model: string) => {
    return import(`./models/${model}`)
      .then((module) => {
        return module;
      })
      .catch(() => {
        return import(`./models/no-settings`);
      });
  };

  const model: string = useWatch({ name: 'model', control });
  const Settings = React.lazy(() => loadModule(model));
  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <Settings />
      </Suspense>
    </>
  );
}
